import _ from 'lodash';

export function objectToQueryParams(obj: any) {
    return _(obj)
        .toPairs()
        .map(pair => pair.map(encodeURIComponent).join('='))
        .join('&');
}
